import { render, staticRenderFns } from "./SlidoWidget.vue?vue&type=template&id=c8f222d6"
import script from "./SlidoWidget.vue?vue&type=script&lang=js"
export * from "./SlidoWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports